import styled from 'styled-components'
import { colors as c } from 'utils'
import { Flex } from 'components'

export const Navigation = styled(Flex)`
  outline: 1px solid ${c('lockedWhite', '10')};
`
